
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11 1C8.5 1 6.5 3 6.5 5.5V9h-1C4.7 9 4 9.7 4 10.5v9c0 .8.7 1.5 1.5 1.5h11c.8 0 1.5-.7 1.5-1.5v-9c0-.8-.7-1.5-1.5-1.5h-1V5.5C15.5 3 13.5 1 11 1zm2.5 8h-5V5.5C8.5 4.1 9.6 3 11 3s2.5 1.1 2.5 2.5V9zM12 14.6v2.2c0 .6-.4 1-1 1s-1-.4-1-1v-2.2c-.6-.3-1-1-1-1.7 0-1.1.9-2 2-2s2 .9 2 2c0 .7-.4 1.3-1 1.7z"}})])
          )
        }
      }
    